// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2fjqW","paramInput":"JobSimulator_paramInput__3fcU3","input":"JobSimulator_input__B4f2X"};